import { Checkbox } from '@/components/ui/Checkbox'
import ProductLink from '@/components/productQuickView/ProductLink'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/Table'
import type { ProductRow } from './api'

interface Props {
  rows: ProductRow[]
  checked: Set<string>
  onToggle: (id: string) => void
  onToggleAll: () => void
}

export default function ProductTable({ rows, checked, onToggle, onToggleAll }: Props) {
  const all = rows.length > 0 && rows.every((r) => checked.has(r.id))
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="h-8 w-8 px-3"><Checkbox checked={all} onChange={onToggleAll} aria-label="Select all" /></TableHead>
          <TableHead className="h-8 px-3 text-foreground">Product</TableHead>
          <TableHead className="h-8 px-3 text-foreground">SKU</TableHead>
          <TableHead className="h-8 px-3 text-right text-foreground">Sold (12 mo)</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.id}>
            <TableCell className="w-8 px-3 py-1"><Checkbox checked={checked.has(r.id)} onChange={() => onToggle(r.id)} aria-label={`Select ${r.name}`} /></TableCell>
            <TableCell className="px-3 py-1"><ProductLink externalId={r.external_id}>{r.name}</ProductLink></TableCell>
            <TableCell className="px-3 py-1 select-all">{r.sku ?? ''}</TableCell>
            <TableCell className="px-3 py-1 text-right tabular-nums">{r.sold_12m.toLocaleString()}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
